import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const AZinformationonline = ({ navigation, route }: any) => {
  const {
    values,
    userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
  } = route.params

  const personalstore = usePersonalStore()
  const intializestore = useInitializeStore()

  const { postazonline, loading } = useFormsStore()

  const handlesubmit = async (signatureDataURL: string) => {
    const data = {
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      completeOnline: true,
      essUserKey: intializestore?.initializeData.userkey,
      entityId: personalstore?.personalData?.entityId,
      typeOfWithhold: values?.typeOfWithhold,
      withholdPercentage: values?.withholdPercentage || null,
      // extraAmount: values?.additionalAmount ? values?.additionalAmount : null,

      sign: signatureDataURL
    }
    const response = await postazonline(data)
    if (response?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    }
    else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }
  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'AZ Withholding Taxation'}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('AZinformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",
          })
        }
        onSubmit={handlesubmit}
      />
    </>
  )
}
export default AZinformationonline
